export type {
  PersistenceAdapter,
  BuiltinAdapterOptions,
} from '../types';

const SHARED_KEY_FRAGMENT = 'shared';

/**
 * Persistence key contract (plan Section "Persistence key contract"):
 *   `bc:filter:${tenantId}:${userId}:${scope}` for page-local;
 *   `bc:filter:${tenantId}:${userId}:shared:${sharedKey}` for cross-page shared.
 */
export function buildStorageKey(opts: {
  tenantId: string;
  userId: string;
  scope: string;
}): string {
  return `bc:filter:${opts.tenantId}:${opts.userId}:${opts.scope}`;
}

export function buildSharedStorageKey(opts: {
  tenantId: string;
  userId: string;
  sharedKey: string;
}): string {
  return `bc:filter:${opts.tenantId}:${opts.userId}:${SHARED_KEY_FRAGMENT}:${opts.sharedKey}`;
}

export const STORAGE_KEY_PREFIX = 'bc:filter:';

export function buildUserKeyPrefix(opts: { tenantId: string; userId: string }): string {
  return `${STORAGE_KEY_PREFIX}${opts.tenantId}:${opts.userId}:`;
}
